import { type ConditionDescriptor } from "../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField } from "../../../../../api/types/svTypes.ts";
import { createLeafConditionDescriptor } from "./conditionDescriptorHelper.ts";

export const hasConditionValues = (condition: ConditionField): boolean =>
  (condition.config?.filter?.values?.length ?? 0) > 0;

export const getValidConditionDescriptors = (
  conditions: ConditionField[],
  withLinked = false
): ConditionDescriptor[] => {
  return getValidConditions(conditions, withLinked)
    .map((vc) => createLeafConditionDescriptor(vc.config.filter))
    .filter((descriptor): descriptor is ConditionDescriptor => !!descriptor);
};

const getValidConditions = (conditions: ConditionField[], withLinked = false): ConditionField[] => {
  return conditions
    .filter((c) => {
      if (c.validation?.invalid) return false;
      if (!withLinked && c.hasLinks) return false;
      return hasConditionValues(c);
    })
    .filter((f): f is ConditionField => !!f)
    .map((f) => structuredClone(f));
};
